import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import style from '../style.module.less'
import Table from './Table'
import Modal from './Modal'
import { Button } from 'hljd'
import store from './store'
import { HeaderView } from '@merchant-backend/common-components'
import { CASE_MANAGE_PATH } from '@constant'
import { getCaseManageTitle, getCaseName } from '@util'

@observer
export default class extends Component {
  render() {
    return (
      <HeaderView
        header={[
          <Link to={CASE_MANAGE_PATH}>{getCaseManageTitle()}</Link>,
          `${getCaseName()}分类`
        ]}
        title={`${getCaseName()}分类`}
        extra={
          <Button
            type="primary"
            style={{ float: 'right', margin: '15px 44px' }}
            onClick={store.showModal()}
          >
            新建分类
          </Button>
        }
      >
        <div className={style.tableWrap} style={{ marginTop: 20 }}>
          <Table />
        </div>

        <Modal />
      </HeaderView>
    )
  }
}
